"use client";
import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Coin from "../../assets/stcoin.png";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { Loader } from "../genericComponents/MainLoader/Loader";

interface StoreCartButtonProps {
  conisDetails: any;
}

export const StoreCartButton: React.FC<StoreCartButtonProps> = ({
  conisDetails,
}) => {
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleNaviagteToCart = (e: any) => {
    e.preventDefault();
    setLoading(true);
    router.push("/products-cart");
  };

  const sumOfQuantities = conisDetails?.productCartDetails?.reduce(
    (total: any, item: any) => total + item.quantity,
    0
  );

  return (
    <>
      {loading && <Loader />}
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: { xs: 0, sm: 20 },
          zIndex: 100,
          width: "100%",
          background: {
            xs: "linear-gradient(180deg, transparent 0%, rgba(245, 251, 247, 0.95) 30%)",
            sm: "none",
          },
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          pb: { xs: "env(safe-area-inset-bottom, 0px)", sm: 0 },
        }}
      >
        <Button
          variant="contained"
          onClick={handleNaviagteToCart}
          sx={{
            margin: "0.5rem",
            width: { xs: "-webkit-fill-available", sm: "25rem" },
            borderRadius: "999px",
            justifyContent: "space-between",
            alignItems: "center",
            background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
            padding: "0.5rem 18px",
            boxShadow: "0 12px 40px rgba(18, 53, 36, 0.28)",
            "&:hover": {
              background: "linear-gradient(135deg, #0f2d1f 0%, #1a6b42 100%)",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#1f7a4d",
                background: "white",
                borderRadius: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "27px",
                height: "27px",
                fontWeight: "bold",
                marginRight: "1rem",
                cursor: "pointer",
              }}
            >
              {sumOfQuantities}
            </Typography>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  marginBottom: "4px",
                }}
              >
                <Image
                  src={Coin}
                  height={500}
                  width={500}
                  alt="coin"
                  style={{
                    width: "1rem",
                    height: "1rem",
                  }}
                />
                &nbsp;
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "600", textTransform: "capitalize" }}
                >
                  {conisDetails?.totalCoins.toLocaleString()} Coins
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  lineHeight: "0px",
                }}
              >
                <Box
                  sx={{
                    width: "0.8rem",
                    height: "0.8rem",
                  }}
                >
                  <Image
                    src={Coin}
                    height={500}
                    width={500}
                    alt="coin"
                    style={{
                      width: "0.8rem",
                      height: "0.8rem",
                      margin: "auto",
                    }}
                  />
                </Box>
                &nbsp;
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "600", textTransform: "capitalize" }}
                >
                  {conisDetails?.cashbackCoins?.toLocaleString()} Cashback Coins
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Typography
              variant="body1"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
                textTransform: "capitalize",
              }}
            >
              Continue <KeyboardArrowRightIcon />
            </Typography>
          </Box>
        </Button>
      </Box>
    </>
  );
};
